import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	applinkErrorHeader: {
		id: 'servicedesk.knowledge-hub.common.applink-error-panel.applink-error-header',
		defaultMessage: 'We couldn’t load this article',
		description: "Error header shown when an article's applink could not be loaded.",
	},
	applinkErrorMessage: {
		id: 'servicedesk.knowledge-hub.common.applink-error-panel.applink-error-message',
		defaultMessage: 'Refresh and try again',
		description: "Error message shown when an article's applink could not be loaded.",
	},
});
